<template lang="pug">
	
	.section-intro

		.title
			h2 {{title}}

		.fixed-image
			.image-mask
				.image-wrapper
					img(:src="src")

</template>


<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import AssetsLoader from '~utils/assetsLoader.js'
	import Scrollable from '~abstracts/scrollable'
	import Globals from '~utils/Globals'

	import $ from 'jquery'
	import { TweenMax } from 'gsap'

	
  @Component({
		name: 'SectionIntro',
		props: ["img","title","fade","onEnter","onLeave"],
		components: { },
		data: function () {
			return {
				src: undefined
			}
		}
	})

	class SectionIntro extends Scrollable {

		mounted () {
			super.mounted()

			this._dom()
			
		}

		init () {
			super.init()

			this.progress = 0
			this.scroller.register(this)
			this.loadImg()
		}

		_dom () {
			this.$fixedImg = this.$el.querySelector('.fixed-image')
			this.$wrapImg = this.$el.querySelector('.image-wrapper')
			this.$img = this.$wrapImg.querySelector('img')
			this.$maskImg = this.$el.querySelector('.image-mask')
			this.$title = this.$el.querySelector('.title h2')
		}

		loadImg() {
			this.bufferImage = new Image()
			this.bufferImage.onload = () => {
				this.src = this.img
			}

			this.bufferImage.src = this.img

		}

		raf (y) {
			super.raf(y)
			// if(!this.scroller.isInViewport(this.bounds.top,this.bounds.height) ) return
			// const perc = this.scroller.getPerc(this.boundsAnim, y)		
			// this.tl && this.tl.progress(perc)
		}

		initTimeline () {
			super.initTimeline()

			const totalHeight = Globals.height + this.bounds.height
			const firstDuration = Globals.height / totalHeight
			const secondDuration = this.bounds.height / totalHeight
			const fade = this.fade || 0

			const height = 550 * Globals.height / 900
			const width = 980 * Globals.width / 1440

			const ratioImg = 980 / 550
			const ratioW = Globals.width / Globals.height


			TweenMax.set(this.$maskImg,{height: height,width: width})
			
			this.tl.add(()=>{

				if(this.scroller.direction == 1 || this.isResized == false) {
					TweenMax.to(this.$maskImg,.6,{height: Globals.height, width: Globals.width, ease:Expo.easeInOut, delay:.0})
					TweenMax.to(this.$img,.8,{scale:1,delay:.2})
					this.onEnter && this.onEnter()

				} else {
					TweenMax.to(this.$maskImg,.8,{height: height,width: width,ease:Expo.easeOut})
					TweenMax.to(this.$img,.4,{scale:1.1})
					this.onLeave && this.onLeave()
				}

				this.isResized = true

			},firstDuration)
			this.tl.fromTo(this.$img,firstDuration,{y:-100},{y:0,ease:Power0.easeNone},0)
			this.tl.fromTo(this.$title,firstDuration,{y:100},{y:0,ease:Power0.easeNone},0)
			this.tl.fromTo(this.$fixedImg,secondDuration,{y:0,opacity:1},{y:this.bounds.height,ease:Power0.easeNone,opacity: fade},(1 - secondDuration))
		}

		_bind () {
			super._bind()
		}

		_on () {
			super._on()
		}

		_off () {
			super._off()
		}


		raf (y) {
			super.raf(y)	
		}

		_resize () {
			super._resize()

			TweenMax.set(this.$wrapImg,{width:Globals.width,height:Globals.height})

			this.boundsAnim = {
				top: this.bounds.top - Globals.height,
				bottom: this.bounds.top + this.bounds.height
			}

			this.initTimeline ()
		}

	}

	export default SectionIntro

</script>

<style lang="stylus" scoped>

	@import '../theme/variables'
	@import '../theme/utils'

	.section-intro
		min-height 100vh
		width 100%
		position relative
		padding-top calc(50vh + 225px)

		+break(xs)
			padding-top 150px !important
			min-height auto

		.title
			width 100%
			text-align center
			position relative
			z-index 80


			h2
				color #fff
				font-size em(100px)
				font-weight 700

				+break(xs)
					font-size 50px

		.fixed-image
			position absolute
			height 100vh
			width 100%
			top 0
			left 0
			will-change transform

			.image-mask
				position absolute
				width 68vw
				height 61vh
				min-width 980px
				min-height 550px
				top 50%
				left 50%
				z-index 60
				overflow hidden
				transform translate3d(-50%,-50%,0)

				+break(xs)
					width 100%

				.image-wrapper
					position absolute
					top 50%
					left 50%
					transform translate3d(-50%,-50%,0)

					+break(xs)
						top 0
						left 0
						transform none

				img
					width 100%
					height 100%
					object-fit cover
					transform scale(1.1)

</style>


// WEBPACK FOOTER //
// section-intro.vue?e79059cc